import { Card, Tabs, Typography } from '@hid-galaxy-ui/galaxy-react';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import { useEffect, useState } from 'react';
import { getAccountDetails } from '../../../services/app-user/app-user';
import { getTranslation } from '../../../utils/functions';
import cx from 'classnames';
import { getCountryNameByCode } from '../../../constants/countryList';
import { IAppProps } from '../../../App';
import { useHistory } from 'react-router-dom';
import buildPATHS from '../../../utils/paths';
import PageLoader from '../../../components/PageLoader';
import PageTitle from '../../../components/PageTitle';
import AccountDetails from '../components/AccountDetails/AccountDetails';
import ChangePassword from '../components/ChangePassword/ChangePassword';
import AccountEdit from '../edit/AccountEdit';
const MyAccounts = (props: IAppProps) => {
  const { toasts, setToasts } = props;
  // const [data, setData] = useState(null);
  const history = useHistory();

  const PATHS = buildPATHS();
  // useEffect(() => {
  //   const fetchAccountDetails = async () => {
  //     try {
  //       const response = await getAccountDetails();
  //       setData(response);
  //     } catch (err) {}
  //   };

  //   fetchAccountDetails();
  // }, []);

  const renderLabel = (label: string) => {
    return <Typography variant={TypographyVariantEnum.H3}>{getTranslation(label)}:</Typography>;
  };

  const renderItem = (item: string) => {
    return <Typography variant={TypographyVariantEnum.H3}>{item ?? '-'}</Typography>;
  };

  const handleShowEdit = () => {
    history.push(PATHS.account_edit);
  };

  const getTabItems = () => {
    const tabItems = [
      {
        key: 'profile',
        label: getTranslation('PROFILE_INFO'),
        content: <AccountEdit toasts={toasts} setToasts={setToasts} />,
      },
      {
        key: 'changePassword',
        label: getTranslation('CHANGE_PASSWORD'),
        content: <ChangePassword toasts={toasts} setToasts={setToasts} />,
      },
    ];
    return tabItems;
  };

  const renderTabs = () => {
    return <Tabs items={getTabItems()} />;
  };
  const renderTitle = () => {
    return <PageTitle>{getTranslation('ACCOUNT_DETAILS')}</PageTitle>;
  };

  // return <Card title={renderTitle()}>{data ? renderTabs() : <PageLoader />}</Card>;
  return <Card title={renderTitle()}>{renderTabs()}</Card>;
};

export default MyAccounts;
